//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { DepartmentUpdatedMessage } from './department-updated.message';

@PresenterType(
{
    model: DepartmentUpdatedMessage
})
@Component({
    selector: 'department-updated-message-template',
    templateUrl: './department-updated-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DepartmentUpdatedMessageTemplateComponent
{
    public data: WritableSignal<DepartmentUpdatedMessage>;
    
    constructor() {
        this.data = signal<DepartmentUpdatedMessage>(null);
    }
}